export default "__VITE_ASSET__ec02ead8__"